import React, { useEffect, useState } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { getAmenity, deleteAmenity } from "../../store/slices/amenity";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function Amenities() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { amenitylist = [], loading } = useSelector((state) => state.amenity);

  const pagelimit = 25;
  const [currentPage, setCurrentPage] = useState(1);

  const fetchAmenities = async () => {
    try {
      await dispatch(getAmenity()).unwrap();
      // toast.success("Amenities loaded successfully ");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAmenities();
  }, []);

  const totalPages = Math.ceil(amenitylist.length / pagelimit);
  const startIndex = (currentPage - 1) * pagelimit;
  const paginatedData = amenitylist.slice(startIndex, startIndex + pagelimit);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this amenity?"))
      return;

    try {
      await dispatch(deleteAmenity(id)).unwrap();
      toast.success("Amenity deleted successfully");
      fetchAmenities();
    } catch (err) {
      console.log(err);
      toast.error(err?.message || "Failed to delete amenity");
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/superadmin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Amenities</span>
        </div>

        {/* Right: Button */}
        <button
          className="add-outlet-btn"
          onClick={() => navigate("/superadmin/addamenity")}
        >
          Add Amenity
        </button>
      </div>

      <Container>
        <Card style={{ border: "none" }}>
          <Card.Body>
            <div className="common-table-wrapper">
              <table className="common-table">
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>#</th>
                    <th>Name</th>
                    <th style={{ width: "140px", textAlign: "center" }}>
                      Icon
                    </th>
                    <th style={{ width: "120px", textAlign: "center" }}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center py-4 text-muted">
                        {loading ? "Loading..." : "No Data Found"}
                      </td>
                    </tr>
                  ) : (
                    paginatedData.map((item, index) => (
                      <tr key={item._id}>
                        <td>{startIndex + index + 1}</td>

                        <td className="text-muted">{item.name}</td>

                        <td style={{ textAlign: "center" }}>
                          <img
                            src={item.iconUrl}
                            alt={item.name}
                            style={{
                              width: "30px",
                              height: "30px",
                              objectFit: "contain",
                            }}
                          />
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center align-items-center gap-3 flex-row">
                            <FaEdit
                              size={18}
                              style={{ cursor: "pointer" }}
                              className="text-primary"
                              onClick={() =>
                                navigate(`/superadmin/editamenity/${item._id}`)
                              }
                            />

                            <FaTrash
                              size={18}
                              style={{ cursor: "pointer" }}
                              className="text-danger"
                              onClick={() => handleDelete(item._id)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {totalPages > 1 && (
                <div className="d-flex justify-content-end gap-2 p-3">
                  <Button
                    size="sm"
                    variant="light"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                  >
                    Prev
                  </Button>

                  {[...Array(totalPages)].map((_, i) => (
                    <Button
                      key={i}
                      size="sm"
                      variant={currentPage === i + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </Button>
                  ))}

                  <Button
                    size="sm"
                    variant="light"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                  >
                    Next
                  </Button>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
